export enum UserScreenCardKeys {
  AppointmentSettings = "appointment-settings"
}
